import { SpotlightStatus } from './spotlight-details/spotlightDetails.types';

export interface StatusConfig {
  color: string;
  label: string;
}

export const getStatusConfig = (status: SpotlightStatus): StatusConfig => {
  switch (status) {
    case SpotlightStatus.PATCHED:
      return {
        color: 'var(--mantine-color-green-6)',
        label: 'Patched',
      };

    case SpotlightStatus.PARTIALLY_PATCHED:
      return {
        color: 'var(--mantine-color-yellow-6)',
        label: 'Partially patched',
      };

    case SpotlightStatus.UNPATCHED:
      return {
        color: 'var(--mantine-color-gray-6)',
        label: 'Unpatched',
      };

    case SpotlightStatus.NOT_APPLICABLE:
      return {
        color: 'var(--mantine-color-gray-6)',
        label: 'Not applicable',
      };

    default:
      return null;
  }
};
